import React, {Component, useContext} from 'react';
import {Layout, Menu, Button, Avatar, Space} from 'antd';
import SVG from 'react-inlinesvg';

//REDUX
import {connect} from 'react-redux';
import {getUser} from '../../actions/user';

import './Header.less';
import {Context} from '../../App';

const {Header: AntHeader} = Layout;

export default function Header() {
    const {user} = useContext(Context);
    const {setPayForUserModal} = useContext(Context);
    return (
        <AntHeader className='header'>
            <a className='logo' href='/'>
                <img src={user?.plan !== 'FREE' ? '/static/images/logo/premium.png' : '/static/images/logo/new.png'} alt='Vantar í bolta?' />
            </a>

            <div>
                <Menu className='main_menu' theme='dark' mode='horizontal'>
                    {/* <Menu.Item>
                        <Search className='searchbar' placeholder='input search loading default' loading />
                    </Menu.Item> */}

                    {user && user.plan === 'FREE' && (
                        <Menu.Item style={{backgroundColor: 'white', cursor: 'pointer', background: 'transparent', height: 64, display: 'flex', alignItems: 'center'}}>
                            <div
                                onClick={() => setPayForUserModal(true)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: 14,
                                    background: '#fffffff0',
                                    padding: '0px 10px',
                                    height: 32,
                                    borderRadius: 10,
                                    boxShadow: '1px 1px 1px 0px #0000006b',
                                    color: '#27005b',
                                }}
                            >
                                <img src='/static/images/logo/premium.png' alt='Áskrift' style={{width: 47}} />
                                Kaupa áskrift
                            </div>
                        </Menu.Item>
                    )}

                    {user?.uuid && (
                        <>
                            <Menu.SubMenu
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                icon={
                                    <Avatar src={user?.image?.image} style={{backgroundColor: '#7f00ff'}}>
                                        {(user.signature_name || '').charAt(0).toUpperCase()}
                                    </Avatar>
                                }
                            >
                                <Menu.Item>
                                    <a href='/stillingar/'>Stillingar</a>
                                </Menu.Item>
                                <Menu.Item>
                                    <a href={'/minn_profill/'}>Prófíllinn minn</a>
                                </Menu.Item>
                                <Menu.Item>
                                    <a href='/utskra/'>Útskrá</a>
                                </Menu.Item>
                            </Menu.SubMenu>
                        </>
                    )}

                    {!window.me && (
                        <Menu.Item style={{backgroundColor: 'transparent', cursor: 'auto'}}>
                            <Space>
                                <Button type='primary' className='btn-success'>
                                    Nýskráning
                                </Button>

                                <Button type='dashed' style={{color: '#000'}}>
                                    <a href='/innskra/'>Innskrá</a>
                                </Button>
                            </Space>
                        </Menu.Item>
                    )}
                </Menu>
            </div>
        </AntHeader>
    );
}
